import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGuard } from './guards/admin.guard';
import { AdminLoginComponent } from './admin/admin-login/admin-login.component';
import { FormCompleteComponent } from './form-complete/form-complete.component';

const routes: Routes = [
    { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
    { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), canActivate: [AdminGuard] },
    { path: 'zendesk', loadChildren: () => import('./zendesk/zendesk.module').then(m => m.ZendeskModule)},
    { path: 'eula-acceptance', loadChildren: () => import('./eula-acceptance/eula-acceptance.module').then(m => m.EulaAcceptanceModule)},
    { path: 'email-verification', loadChildren: () => import('./email-verification/email-verification.module').then(m => m.EmailVerificationModule)},
    { path: 'adminLogin', component: AdminLoginComponent },
    { path: 'form-complete', component: FormCompleteComponent },
    { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
